<template>
  <div>
    <PlanControlItem v-for="data in planControl" :v-key="data.id" :item="data"></PlanControlItem>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import PlanControlItem from '@/components/PlanControlItem'

  export default {
    components: {PlanControlItem},
    data() {
      return {}
    },
    mounted() {
      this.$store.dispatch('Docflow/getPlanControl', this.$route.params.documentId)
    },
    computed: {
      ...mapState('Docflow', ['planControl'])
    }
  }
</script>

